export enum DownloadButtonEvents {
  OnDownloadClicked = 'downloadClicked',
  OnDownloadStarted = 'downloadStarted',
  OnDownloadSecurityContainer = 'downloadSecurityContainer',
  OnDownloadK8sAgent = 'downloadK8sAgent',
}

export class OnDownloadClicked extends CustomEvent<{}> {
  constructor() {
    super(DownloadButtonEvents.OnDownloadClicked, {
      detail: {},
      bubbles: true,
      composed: true,
    });
  }
}

export class OnDownloadStarted extends CustomEvent<{}> {
  constructor() {
    super(DownloadButtonEvents.OnDownloadStarted, {
      detail: {},
      bubbles: true,
      composed: true,
    });
  }
}

export class OnDownloadSecurityContainer extends CustomEvent<{ packageId: string }> {
  constructor(packageId: string) {
    super(DownloadButtonEvents.OnDownloadSecurityContainer, {
      detail: {
        packageId,
      },
      bubbles: true,
      composed: true,
    });
  }
}
export class OnDownloadK8sAgent extends CustomEvent<{}> {
  constructor() {
    super(DownloadButtonEvents.OnDownloadK8sAgent, {
      bubbles: true,
      composed: true,
    });
  }
}
